module.exports = __webpack_public_path__ + "static/media/saee_chavan.3955e847.png";